import {useEffect, type ReactNode} from 'react';
import {usePortalPopoutManager} from './hooks/usePortalPopoutManager';
import {usePortalPopout} from './hooks/usePortalPopout';
import type {PortalPopoutContentProps} from './PortalPopoutReduxContext';

// ----------------------------
// PortalPopoutContent
// ----------------------------
export const PortalPopoutContent = ({
  popoutId,
  children,
  placeholder = null,
  className = '',
  style = {},
  title,
  windowFeatures,
  tabRoot,
}: PortalPopoutContentProps): ReactNode => {
  const {registerContent, unregisterContent, openPopout} =
    usePortalPopoutManager();
  const {isOpen, isReady} = usePortalPopout(popoutId);
  // ---------------

  // Register content with the manager when component mounts or children change
  useEffect(() => {
    registerContent(popoutId, children);

    return () => {
      unregisterContent(popoutId);
    };
  }, [popoutId, children, registerContent, unregisterContent]);
  // ---------------

  useEffect(() => {
    if (isOpen && (title || windowFeatures)) {
      // Options are passed when openPopout is called from trigger
    }
  }, [isOpen, title, windowFeatures, openPopout, popoutId]);

  if (isOpen && isReady) {
    if (placeholder) {
      return (
        <div
          className={`portal-popout-placeholder ${className}`}
          style={style}
          data-testid={`portal-popout-redux-contentplaceholder-${popoutId}`}
          data-tab-root={tabRoot}
        >
          {placeholder}
        </div>
      );
    }
    return null;
  }
  // ---------------

  return (
    <div
      className={`portal-popout-inline ${className}`}
      style={style}
      data-testid={`portal-popout-redux-content-div-children-${popoutId}`}
      data-tab-root={tabRoot}
    >
      {children}
    </div>
  );
};

export default PortalPopoutContent;
